import React from 'react'
import AITestContext from '../../../contexts/AITestContext'
import StatusContext from '../../../contexts/StatusContext';
import AuthContext from "../../../contexts/AuthContext.js";

import { useParams } from "react-router-dom"
import { useLocation } from 'react-router-dom'
import { useEffect, useState } from "react";
import { NavBarTest } from '../navbartest/NavBarTest'
import { NavBarCollegeTest } from '../navbarcollegetest/NavBarCollegeTest'
import { AlertDialog } from '../alertdialog/AlertDialog'
import { ConfirmDialog } from '../alertdialog/ConfirmDialog'
import { CreateTest } from '../aitest/CreateTest'
import { ChooseTest } from '../aitest/ChooseTest'
import { CollegeTest } from './CollegeTest.jsx';
import { CreateCollegeTest } from './CreateCollegeTest.jsx';
import { ProgressIcon } from '../customicons/ProgressIcon';
import { LoginDialog } from '../logindialog/LoginDialog'
import { CardWithoutImage } from './../cardwithoutimage/CardWithoutImage'

import AIButton from '../aibutton/AIButton.jsx';
import { DialogSelectModels } from '../aibutton/DialogSelectModels';
import DialogTestBought from './DialogTestBought.jsx';
import { DialogMoreAnswerProgress } from './DialogMoreAnswerProgress.jsx';
import { DialogMoreAnswer } from './DialogMoreAnswer';
import { Colleges } from './colleges/Colleges.jsx';

import "./aitest.css"


export const AITest = () => {

  const [openConfirmDialog, handleConfirmDisplay] = useState(false);
  const [dialogtext, setDialogText] = useState('');

  const { token } = useParams()

  const {
    onClearQuestions,
    displaySample,
    onSaveChosenTest,
    onSaveChosenCollegeTest,
    onChangeContext,
    onCreateTest,
    createtestmode,
    onChooseTest,
    selecttestmode,
    status,
    isLoading,
    handleSaveChosenTestDialog,
    openSaveChosenTestDialog,
    setShowTestBought,
    collegetestmode,

    createcollegetestmode,
    onCreateCollegeTest,
    
  } = React.useContext(AITestContext);

  const {
    checkCurrentUser,
  } = React.useContext(AuthContext);

  const {
    isMe,
    isMobile,
    changeLanguage,
    openDialog,
    closeDialogBox,
    setShowLoginDialog,
    getAIProvider,
    getAIName,
    onClickAIButton,
  } = React.useContext(StatusContext);

  var sample = '';
  const location = useLocation()
  if (location.state !== null)
    sample = location.state.sample

  useEffect(() => {
    console.log("useEffect: aitest:", {token})
    const setSample = () => {
      if (sample) {
        displaySample(sample)
        location.state.sample = '';
      }
    }

    const verifyToken = () => {
      console.log("Toeken:", token)

      if ( token === 'MyTestPurchaseSussess' )
      {
        setShowTestBought(true)
        return
      }
    }

  verifyToken()
    setSample();
  }, [sample, displaySample, location.state, token, setShowTestBought])

  
  const alertYesSaveChosenTest = () => {
    setDialogText('')
    handleSaveChosenTestDialog(false)
    if (collegetestmode)
       onSaveChosenCollegeTest()
    else
      onSaveChosenTest()
  }
  const alertCancelSaveChosenTest = () => {
    handleSaveChosenTestDialog(false)
  }

  const closeSaveChosenTestDialog = () => {

    handleSaveChosenTestDialog(false)
  };

  const alertYes = () => {
    onClearQuestions()
    closeDialogBox()
  }

  const alertCancel = () => {
    closeDialogBox()
  }

  const closeConfirmDialogBox = () => {
    handleConfirmDisplay(false);
  };

  const confirmYes = () => {
    closeConfirmDialogBox()
  }

   const handleOnCreateCollegeTest = () => {

    if (checkCurrentUser() === false) {
      setShowLoginDialog(true)
      return;
    }
  
    onCreateCollegeTest()
  }

  const handleOnChooseTest = () => {

    if (checkCurrentUser() === false) {
      setShowLoginDialog(true)
      return;
    }
    onChooseTest()
  }

  const handleOnCreateTest = () => {

    if (checkCurrentUser() === false) {
      setShowLoginDialog(true)
      return;
    }
    onCreateTest()
  }


  const styles = {
    container: {
      alignItems: 'center', // Center vertically
      position: 'relative',
      width: '100%',
      border: 'none',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
     
    },
    containerMobile: {
      alignItems: 'right', // Center vertically
      position: 'relative',
      width: '100%',
      border: 'none',
    },
     containerRight: {
      alignItems: 'left', // Right vertically
      position: 'relative',
      width: '100%',
      border: 'none',
     
    },
    title: {
      fontWeight: '700',
      fontStyle: 'oblique',
    },
    text: {
      marginRight: '20px', // Optional spacing after the text
    },
  
  }


  return (

    <div className="homeContainer">
      {
          (createtestmode) &&
           <AIButton pane={0} provider = {getAIProvider()} model = {getAIName()} onClick = {()=>{onClickAIButton(0)}}/>
      }

        {
          createcollegetestmode ?
          <NavBarCollegeTest title={changeLanguage('aitest', 'navbartitle')} />
          :
          <NavBarTest title={changeLanguage('aitest', 'navbartitle')} />
        }
    
        {
          (collegetestmode) &&
          <CollegeTest />
        }

        {
          
          (isMe() && createcollegetestmode) &&
          <CreateCollegeTest onChange={onChangeContext} />
        
        }


        {
          
          (isMe() && selecttestmode) &&
          <ChooseTest />
      
        }

        {
          
          ( isMe() && createtestmode) &&
          <CreateTest onChange={onChangeContext} />
          
        }
      

        {
          (status) && <label className='statusLabel'>{status}</label>
        }

        <div style={!isMobile() ? styles.container : styles.containerMobile}>
          {
            (!createtestmode && !selecttestmode) && !collegetestmode && !createcollegetestmode && 

            <>
          
              <br></br>
              <br></br>
            
              {

                <>
                  <div className ='collegeTestsContainer' >
                    <Colleges  header={changeLanguage('aitest', 'collegetests')}
                      text={changeLanguage('aitest', 'text14')}
                      />
                  </div>
                  <br></br>
                </>
              }

              {
                isMe() && 
                <>
                <div className ='collegeTestsContainer'>
                  <CardWithoutImage header={changeLanguage('aitest', 'createcollegetests')}
                    text={changeLanguage('aitest', 'text14')}
                    onClick={handleOnCreateCollegeTest} />
                </div>
                <br></br>
              </>
              }
              {
                isMe() &&
                <>
                  <div className ='collegeTestsContainer'>
                    <CardWithoutImage header={changeLanguage('aitest', 'selecttest')}
                      text={changeLanguage('aitest', 'text14')}
                      onClick={handleOnChooseTest} />
                  </div>
                  <br></br>
                </>
              }

              {
                isMe() &&
                <>
                  <div className ='collegeTestsContainer'>
                    <CardWithoutImage header={changeLanguage('aitest', 'createtest')}
                      text={changeLanguage('aitest', 'text10')}
                      onClick={handleOnCreateTest} />
                  </div>
                  <br></br>
                </>
              }

            </>
          }
        
        </div>

        

        <LoginDialog />
        <AlertDialog alertYes={alertYes} alertCancel={alertCancel} openDialog={openDialog} closeDialog={closeDialogBox} prompt={changeLanguage('dialog', 'cleardata')} />
        <AlertDialog alertYes={alertYesSaveChosenTest} alertCancel={alertCancelSaveChosenTest} openDialog={openSaveChosenTestDialog} closeDialog={closeSaveChosenTestDialog} prompt={changeLanguage('aitest', 'savechosentest')} />
        <ConfirmDialog alertYes={confirmYes} openDialog={openConfirmDialog} closeDialog={closeConfirmDialogBox} prompt={dialogtext} />
        <ProgressIcon isLoading={isLoading} />
        <DialogSelectModels />
        <DialogTestBought />
        <DialogMoreAnswer />
        <DialogMoreAnswerProgress />
     

    </div>
  )
}


